import React, { useMemo } from 'react';
import { ActivityType, Box, CategoryIcon, List, ShimmerBox } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { EMPTY_FIELD_VALUE, SHORT_DATE_FORMAT } from '@/common/constants';
import { Service } from '@/modules/employee/Employee/Documents/queries/useGetClaimServices.query';
import { formatCurrency } from '@/utils';

import { LettersOfMedicalNecessity, LMNClaim } from '../LettersOfMedicalNecessity.types';
import { LettersOfMedicalNecessityClaims } from '../LettersOfMedicalNecessityClaims/LettersOfMedicalNecessityClaims';

interface Props extends LettersOfMedicalNecessity {
  claim: LMNClaim;
  service?: Service;
  isLoading?: boolean;
}

const LettersOfMedicalNecessityClaimListItem: React.FC<Props> = ({ claim, service, isLoading }) => {
  const formattedDate = useMemo(() => {
    if (!claim.serviceOn) return EMPTY_FIELD_VALUE;

    return dayjs(claim.serviceOn).format(SHORT_DATE_FORMAT);
  }, [claim.serviceOn]);

  if (isLoading) {
    return <ShimmerBox height="76px" width="100%" margin={{ top: 'spacing8' }} />;
  }

  return (
    <List.Item pad={{ vertical: 'spacing12', horizontal: 'spacing24' }} testId="lmn-claim-list_item">
      <List.Item.Text flex={2} testId={`lmn-claim-list_item_${claim.claimId}_provider`}>
        <Box direction="row" align="center" gap="spacing12">
          <CategoryIcon category={service?.categoryType as ActivityType} />
          <LettersOfMedicalNecessityClaims claim={claim} />
        </Box>
      </List.Item.Text>

      <List.Item.Text weight={400} flex={1.2} size="16px" testId={`lmn-claim-list_item_${claim.claimId}_amount`}>
        {formatCurrency(claim.requestedAmount)}
      </List.Item.Text>

      <List.Item.Text weight={400} flex={0.8} size="16px" color="textSecondary" testId={`lmn-claim-list_item_${claim.claimId}_date`}>
        {formattedDate}
      </List.Item.Text>
    </List.Item>
  );
};

export default LettersOfMedicalNecessityClaimListItem;
